import { useIntl } from 'react-intl';
import useUser from '@alltrails/context/hooks/useUser';
import { isSubscriber } from '@alltrails/context/utils/isSubscriber';
import Logo from '@alltrails/denali/components/Logo';
import PlusLogoBadge from '@alltrails/denali/components/SubscriptionBadge/Logo/Plus';
import styles from './MinimalHeader.module.scss';

export default function MinimalHeader({ showStandardLogo = false }: { showStandardLogo?: boolean }) {
  const intl = useIntl();
  const user = useUser();

  return (
    <header className={styles.header}>
      <a aria-label={intl.formatMessage({ defaultMessage: 'AllTrails home' })} href="/">
        {isSubscriber(user) && !showStandardLogo ? <PlusLogoBadge variant="full" /> : <Logo size="sm" color="colored-dark" variant="logomark" />}
      </a>
    </header>
  );
}
